/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import { Fragment, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect, useSelector, useStore } from 'react-redux';
import count from 'transmute/count';
import get from 'transmute/get';
import { isEveryone, isPrivate, isSpecific
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/permission/assignment-mode';
import { AssetPermission } from 'dashboard-lib/public/permission/asset-permission';
// @ts-expect-error migrate upstream
import { useOpenState } from 'dashboard-components/dashboard-actions/useOpenState';
// @ts-expect-error migrate upstream
import { createMessage } from 'dashboard-components/message/message';
import { useEntityDeps, useFetchEntityDeps
// @ts-expect-error migrate upstream
} from 'dashboard-components/permission/useEntityDeps';

// @ts-expect-error migrate upstream
import { getUserLabel } from 'dashboard-lib/public/users/users-logic';
// @ts-expect-error migrate upstream
import { selectUser } from 'dashboard-lib/public/users/users-selector';
import { selectTeam, selectParentTeamIdSet
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/team/team-selector';
// @ts-expect-error migrate upstream
import { getName as getTeamName } from 'dashboard-lib/public/team/team-schema';
// @ts-expect-error migrate upstream
import { lang } from 'dashboard-lib/private/js-util';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';

// @ts-expect-error migrate upstream
import { track } from 'dashboard-ui-components/tracking/DashboardUITracker';
// @ts-expect-error migrate upstream
import { useRefCache } from 'dashboard-components/hooks/useRefCache';
// @ts-expect-error migrate upstream
import { useShowDialog } from 'reporting-action-components/dialog/ducks';

// @ts-expect-error migrate upstream
import { selectDashboardPermissionConfigAsState } from 'dashboard-lib/public/permission/permission-selector';
// @ts-expect-error migrate upstream
import { DASHBOARD_SET_PERMISSION } from 'dashboard-lib/public/action/reporting-action';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  VIEW,
  EDIT
} = AssetPermission;
const EntityLabelList = props => {
  const {
    selectedTeamSet,
    selectedUserSet
  } = props;
  const {
    teamMap,
    userMap
  } = useEntityDeps();
  const userLabels = useMemo(() => selectedUserSet.map(id => getUserLabel(get(id, userMap)) || id), [selectedUserSet, userMap]);
  const teamLabels = useMemo(() => selectedTeamSet.map(id => getTeamName(get(id, teamMap)) || id), [selectedTeamSet, teamMap]);
  const entityLabels = teamLabels.concat(userLabels);
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "400",
    as: "div",
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: 100,
      gradientColor: "fill-surface-default",
      size: 28,
      children: entityLabels.join(', ')
    })
  });
};
const EntityButton = props => {
  const {
    onClick,
    selectedTeamSet,
    selectedUserSet
  } = props;
  const allEntity = selectedTeamSet.concat(selectedUserSet);
  const allEntitySize = allEntity.size;
  const firstUserId = selectedUserSet.first();
  const firstUser = useSelector(selectUser(firstUserId));
  const firstTeamId = selectedTeamSet.first();
  const firstTeam = useSelector(state => selectTeam(state, firstTeamId));
  const getText = () => {
    let firstEntity;
    if (firstTeamId) {
      firstEntity = getTeamName(firstTeam) || firstTeamId;
    } else if (firstUserId) {
      firstEntity = getUserLabel(firstUser) || firstUserId;
    }
    if (allEntitySize === 0) {
      return null;
    }
    if (allEntitySize === 1) {
      return firstEntity;
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.action.permission.label.entityButton",
      options: {
        firstEntity,
        restEntityCount: allEntitySize - 1
      }
    });
  };
  return /*#__PURE__*/_jsx(UIButton, {
    className: "m-left-2",
    use: "link",
    onClick: onClick,
    children: getText()
  });
};
const toPopoverHeaderLang = ({
  assignmentMode,
  permissionValue
}) => {
  const headerLang = lang('dashboard.action.permission.popover.header');
  if (isSpecific(assignmentMode)) {
    if (permissionValue === EDIT) {
      return headerLang('specificEdit');
    } else if (permissionValue === VIEW) {
      return headerLang('specificView');
    }
  }
  if (isEveryone(assignmentMode)) {
    if (permissionValue === EDIT) {
      return headerLang('everyoneEdit');
    } else if (permissionValue === VIEW) {
      return headerLang('everyoneView');
    }
  }
  return headerLang('ownerOnly');
};
const PopoverAssigneeLabelMessage = createMessage('dashboard.action.permission.popover.body.assigneeLabel');
const PopoverFooterEditMessage = createMessage('dashboard.action.permission.popover.footer.edit');
const PopoverFooterCloseMessage = createMessage('dashboard.action.permission.popover.footer.close');
const SpecificMessage = createMessage('dashboard.action.permission.label.SPECIFIC');
const EveryoneEditMessage = createMessage('dashboard.action.permission.label.EVERYONE_EDIT');
const EveryoneViewMessage = createMessage('dashboard.action.permission.label.EVERYONE_VIEW');
const PrivateMessage = createMessage('dashboard.action.permission.label.PRIVATE');
const PermissionActionButton = props => {
  const {
    dashboardId,
    dashboardName,
    disabled = false,
    DisabledMessage = () => null,
    assignmentMode,
    permissionValue,
    selectedTeamSet,
    selectedUserSet
  } = props;
  useFetchEntityDeps();
  const {
    isOpen,
    open,
    close
  } = useOpenState();
  const store = useStore();
  const state = store.getState();

  // Fetching permissions for an asset returns the child-most teams
  // for access. FE needs to then derive the parent teams from the child
  // team IDs to properly render to users what teams have access
  // to the given dashboard.
  const partialSelectParentTeamIdSet = useCallback(teamId => selectParentTeamIdSet(state, teamId), [state]);
  let parentAndChildTeamSet = selectedTeamSet;
  for (const childTeamId of selectedTeamSet) {
    const parentTeamIdSet = partialSelectParentTeamIdSet(childTeamId);
    parentAndChildTeamSet = parentAndChildTeamSet.concat(
    // TODO: FIX this
    parentTeamIdSet);
  }
  const trackedProperties = useRefCache({
    assignmentMode,
    permissionValue,
    teamCount: count(selectedTeamSet || []),
    userCount: count(selectedUserSet || []),
    dashboardId
  });
  const onClickAssignmentText = useCallback(() => {
    track('clickAssignmentText', trackedProperties);
    open();
  }, [trackedProperties, open]);
  const onOpenChange = useCallback(evt => {
    const didOpen = evt.target.value;
    if (didOpen) {
      onClickAssignmentText();
    } else {
      close();
    }
  }, [close, onClickAssignmentText]);
  const showDialog = useShowDialog();
  const onClickEdit = useCallback(() => {
    track('clickEditAccess', trackedProperties);
    close();
    showDialog({
      dialogType: DASHBOARD_SET_PERMISSION,
      dialogProps: {
        dashboardId,
        dashboardName,
        eventTracker: track
      }
    });
  }, [close, trackedProperties, dashboardId, dashboardName, showDialog]);
  const PopoverHeader = /*#__PURE__*/_jsx("h5", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: toPopoverHeaderLang({
        assignmentMode: assignmentMode,
        permissionValue: permissionValue
      })
    })
  });
  const PopoverBody = isSpecific(assignmentMode) && /*#__PURE__*/_jsxs("div", {
    style: {
      width: 300
    },
    children: [/*#__PURE__*/_jsx(PopoverAssigneeLabelMessage, {}), /*#__PURE__*/_jsx(EntityLabelList, {
      selectedTeamSet: parentAndChildTeamSet,
      selectedUserSet: selectedUserSet
    })]
  });
  const PopoverFooter = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UITooltip, {
      disabled: !disabled,
      title: DisabledMessage && /*#__PURE__*/_jsx(DisabledMessage, {}),
      placement: "bottom",
      children: /*#__PURE__*/_jsx(UIButton, {
        disabled: disabled,
        use: "tertiary",
        onClick: onClickEdit,
        children: /*#__PURE__*/_jsx(PopoverFooterEditMessage, {})
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      onClick: close,
      children: /*#__PURE__*/_jsx(PopoverFooterCloseMessage, {})
    })]
  });
  const Popover = useMemo(() => ({
    children
  }) => /*#__PURE__*/_jsx(UIPopover, {
    placement: "bottom left",
    open: isOpen,
    onOpenChange: onOpenChange,
    content: {
      header: PopoverHeader,
      body: PopoverBody,
      footer: PopoverFooter
    },
    children: children
  }), [isOpen, onOpenChange, PopoverHeader, PopoverBody, PopoverFooter]);
  const specificButton = /*#__PURE__*/_jsx(Popover, {
    children: /*#__PURE__*/_jsx(EntityButton, {
      onClick: onClickAssignmentText,
      selectedTeamSet: parentAndChildTeamSet,
      selectedUserSet: selectedUserSet
    })
  });
  const nonSpecificButton = /*#__PURE__*/_jsx(Popover, {
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: onClickAssignmentText,
      children: /*#__PURE__*/_jsxs("strong", {
        children: [isEveryone(assignmentMode) && permissionValue === EDIT && /*#__PURE__*/_jsx(EveryoneEditMessage, {}), isEveryone(assignmentMode) && permissionValue === VIEW && /*#__PURE__*/_jsx(EveryoneViewMessage, {}), isPrivate(assignmentMode) && /*#__PURE__*/_jsx(PrivateMessage, {})]
      })
    })
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [isSpecific(assignmentMode) && /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(SpecificMessage, {})
    }), !isSpecific(assignmentMode) && nonSpecificButton, isSpecific(assignmentMode) && specificButton]
  });
};
PermissionActionButton.propTypes = {
  assignmentMode: PropTypes.string.isRequired,
  dashboardId: PropTypes.number.isRequired,
  dashboardName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  DisabledMessage: PropTypes.elementType,
  permissionValue: PropTypes.string.isRequired,
  selectedUserSet: ImmutablePropTypes.set.isRequired,
  selectedTeamSet: ImmutablePropTypes.set.isRequired
};
export default connect(state => {
  const dashboardConfig = selectDashboardPermissionConfigAsState(state);
  return dashboardConfig;
})(PermissionActionButton);